/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useState, useEffect } from 'react';
import "../assets/styles.css";
// import image1 from "../assets/img/mint-punk.png";
import NavBar from '../components/NavBar';
// import Footer from '../components/Footer';
import { ethers } from "ethers";
import axios from "axios"
// import { Table } from "react-bootstrap";
import { CircularProgress } from "@mui/material"
import { toast } from 'react-hot-toast'
import { useAccount } from 'wagmi'
import { writeContract } from '@wagmi/core'
import { waitForTransaction } from '@wagmi/core'

import stakingContract from "../artifacts/NFTStakingVault.sol/NFTStakingVault.json";
import multiCallAbi from "../artifacts/multiCallAbi.json";
import nftContract from "../artifacts/LION.sol/LION.json";
import { stakingContractAddresses, nftContractAddresses, multicallAddresses } from "../utils/contracts-config";
import { createPublicClient, http } from 'viem'
import { sepolia } from 'viem/chains'
import { config } from '../config.jsx';

function StakingPage() {
    const { address, chainId } = useAccount()
    // const [mintAmount,] = useState(1)
    const [userNfts, setUserNfts] = useState([])
    const [info, setInfo] = useState({
        currentSupply: 0,
        maxSupply: 0,
        maxMintAmountPerTx: 5,
        mintCost: 0,
        paused: 1,
        userNftIds: [],
        stakedNftIds: [],
        totalReward: 0
    })
    const [loading, setLoading] = useState(false)


    const r0artestnet = {
        id: 11166111,
        network: "r0artestnet",
        name: "R0ARTestNet",
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
        },
        rpcUrls: {
            default: {
                http: ["https://testnet.rpc-r0ar.io"],
            },
        },
        blockExplorers: {
            default: {
                name: "R0AR Testnet Exploerer",
                url: "https://testnet.r0arscan.io",
            },
        },
        testnet: true,
    };

    const publicClient = createPublicClient({
        chain: chainId === 11155111 ? sepolia : r0artestnet,
        transport: http()
    })

    let multicallAddress = chainId === 11155111 ? multicallAddresses[0] : multicallAddresses[1]
    let nftContractAddress = chainId === 11155111 ? nftContractAddresses[0] : nftContractAddresses[1]
    let stakingContractAddress = chainId === 11155111 ? stakingContractAddresses[0] : stakingContractAddresses[1]

    const getInfo = async () => {
        let stakedTokens, reward, paused, userToken, userTokens, maxMintAmountPerTx, cost, baseURI, baseExtension, totalSupply, maxSupply
        if (address) {
            const AllInfo = await publicClient.readContract(config, {
                address: multicallAddress,
                abi: multiCallAbi,
                functionName: 'AllInfo',
                args: [address],
                chainId: chainId
            })
            stakedTokens = Array.from((AllInfo[0]), x => Number(x))
            reward = AllInfo[1]
            userToken = AllInfo[2]
            paused = AllInfo[3]
            userTokens = Array.from((userToken), x => Number(x))
            maxMintAmountPerTx = AllInfo[4]
            cost = AllInfo[5]
            baseURI = AllInfo[6]
            baseExtension = AllInfo[7]
            totalSupply = AllInfo[8]
            maxSupply = AllInfo[9]
            userTokens = userTokens.concat(stakedTokens).sort()
        } else {
            const nftInfo = await publicClient.readContract({
                address: multicallAddress,
                abi: multiCallAbi,
                functionName: 'nftInfo'
            })
            paused = nftInfo[0]
            maxMintAmountPerTx = nftInfo[1]
            cost = nftInfo[2]
            baseURI = nftInfo[3]
            baseExtension = nftInfo[4]
            totalSupply = nftInfo[5]
            maxSupply = nftInfo[6]
        }

        setInfo({
            currentSupply: Number(totalSupply),
            maxSupply: Number(maxSupply),
            maxMintAmountPerTx: Number(maxMintAmountPerTx),
            mintCost: Number(ethers.utils.formatUnits(cost, "ether")),
            paused: Number(paused),
            userNftIds: userTokens,
            stakedNftIds: stakedTokens,
            totalReward: reward !== undefined ? Number(ethers.utils.formatUnits(reward, "ether")) : 0
        })

        const _userNfts = await Promise.all(userTokens.map(async (nft) => {
            const baseUris = baseURI.replace("ipfs.io", "teal-holy-ox-590.mypinata.cloud")
            const url = baseUris + nft.toString() + baseExtension
            console.log(url)
            const metadata = await axios.get(
                url
            )
            return {
                id: nft,
                uri: metadata.data.image
            }
        }))
        setUserNfts(_userNfts)
    }


    const stakeItem = async (id) => {
        try {
            setLoading(true)
            const approve_tx = await writeContract(config, {
                address: nftContractAddress,
                abi: nftContract.abi,
                functionName: 'approve',
                args: [stakingContractAddress, id]
            })
            await waitForTransaction(config, {
                hash: approve_tx.hash
            })
            toast.success('Successfully approved')
            const stake_tx = await writeContract(config, {
                address: stakingContractAddress,
                abi: stakingContract.abi,
                functionName: 'stake',
                args: [[id]]
            })
            await waitForTransaction(config, {
                hash: stake_tx.hash
            })
            setLoading(false)
            toast.success('Successfully staked')
            getInfo()
        } catch (error) {
            setLoading(false)
            toast.error('There is some problem on staking. please try again later')
            console.log(error)
        }

    }

    const unstakeItem = async (id) => {
        try {
            setLoading(true)
            const unstake_tx = await writeContract(config, {
                address: stakingContractAddress,
                abi: stakingContract.abi,
                functionName: 'unstake',
                args: [[id]]
            })
            await waitForTransaction(config, {
                hash: unstake_tx.hash
            })
            setLoading(false)
            toast.success('Successfully unstaked')
            getInfo()
        } catch (error) {
            setLoading(false)
            toast.error('There is some problem on unstaking. please try again later')
            console.log(error)
        }
    }

    const unstakeAll = async () => {
        try {
            setLoading(true)
            const unstake_tx = await writeContract(config, {
                address: stakingContractAddress,
                abi: stakingContract.abi,
                functionName: 'unstake',
                args: [info.stakedNftIds]
            })
            await waitForTransaction(config, {
                hash: unstake_tx.hash
            })
            setLoading(false)
            toast.success('Successfully unstaked')
            getInfo()
        } catch (error) {
            setLoading(false)
            toast.error('There is some problem on unstaking. please try again later')
            console.log(error)
        }
    }

    const claim = async () => {
        try {
            setLoading(true)
            const claim_tx = await writeContract(config, {
                address: stakingContractAddress,
                abi: stakingContract.abi,
                functionName: 'claim',
                args: [info.stakedNftIds]
            })
            await waitForTransaction(config, {
                hash: claim_tx.hash
            })

            setLoading(false)
            toast.success('Successfully claimed')
            getInfo()
        } catch (error) {
            setLoading(false)
            toast.error('There is some problem on claiming. please try again later')
            console.log(error)
        }
    }

    // useEffect(() => {
    //     getInfo()
    // }, [address])

    return (
        <section className='hero'>
            <NavBar />
            <br />
            {/* <section className='my-items'>
                {userNfts.length !== 0 ? (
                    <>
                        <p className='minttitle title' style={{ color: 'black' }}>My Lion</p>
                        <div className='items container'>
                            {userNfts.map((nft, index) => {
                                return (
                                    <div className='item-box' key={index}>
                                        <img src={nft.uri} className="item-img" />
                                        <div className='text-center'>
                                            {info.stakedNftIds.includes(nft.id) ? (
                                                <button className="btn m-3 activeButton roleButton" role="button" onClick={() => { unstakeItem(nft.id) }} style={{ backgroundColor: '#00ff84', fontWeight: '500' }}>
                                                    {loading ? <CircularProgress color="inherit" size={18} /> : "UNSTAKE"}
                                                </button>
                                            ) : (
                                                <button className="btn btn-info m-3 activeButton roleButton" role="button"
                                                    onClick={() => { stakeItem(nft.id) }} style={{ backgroundColor: '#00ff84', fontWeight: '500' }}>
                                                    {loading ? <CircularProgress color="inherit" size={18} /> : "STAKE"}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </>
                ) :
                    <>
                        <p className='minttitle title' style={{ color: 'black' }}>Lions</p>
                        <div className='items container'>
                            <div className='item-box' key={0}>
                                <img src='https://r0arswap.com/images/the-lion-tribe/1.png' className="item-img" />
                                <div className='text-center'>
                                </div>
                            </div>
                            <div className='item-box' key={1}>
                                <img src='https://r0arswap.com/images/the-lion-tribe/1.png' className="item-img" />
                                <div className='text-center'>
                                </div>
                            </div>
                            <div className='item-box' key={2}>
                                <img src='https://r0arswap.com/images/the-lion-tribe/1.png' className="item-img" />
                                <div className='text-center'>
                                </div>
                            </div>
                        </div>
                    </>}
            </section> */}
            <section className="claim" id="claim" style={{ marginTop: '110px' }}>
                <div className="roadmap-container"  >
                    {address ?
                        <div className='staking-info-container'>
                            <p className='minttitle title'>Staking Info</p>
                            <div className='mintInfoBox'>
                                <span className='p-2'>Coming Soon</span>
                                {/* {info.userNftIds.length > 0 ?
                                    <>
                                        <tr>
                                            <td className='p-2'>Your LION </td>
                                            <td className='p-3'>[{info.userNftIds.join(" ")}]</td>
                                        </tr>
                                        <tr>
                                            <td className='p-2'>Items Count</td>
                                            <td className='p-3'>{info.userNftIds.length}</td>
                                        </tr>
                                    </> :
                                    <>
                                        <span className='p-2'>There is no minted NFT. Please mint NFT first</span>
                                        <a href="https://opensea.io/collection/executive-r0ar-society/overview" target="_blank" rel="noreferrer">
                                            <button className="navConnectButton" style={{ marginLeft: '0px' }}>
                                                Mint Now
                                            </button>
                                        </a>
                                    </>
                                } */}
                                {/* {info.stakedNftIds.length > 0
                                    ?
                                    <tr>
                                        <td className='p-2'>Items Staked</td>
                                        <td className='p-3'>[{info.stakedNftIds.join(" ")}]</td>
                                    </tr> :
                                    <>
                                        <span className='p-2'>There is no staked NFT. Please stake NFT first</span>
                                    </>
                                }
                                {info.totalReward > 0
                                    ? <tr>
                                        <td className='p-2'>Earned Reward</td>
                                        <td className='p-3'>
                                            {info.totalReward !== 0 ?
                                                parseFloat(info.totalReward).toFixed(6) : 0
                                            }
                                        </td>
                                    </tr> :
                                    <></>
                                } */}
                            </div >
                            {info.stakedNftIds.length > 0 ?
                                <div style={{ textAlign: "center" }} >
                                    <button className="btn m-3 activeButton roleButton" src="" onClick={claim} style={{ backgroundColor: '#00ff84', fontWeight: '500' }}>
                                        {loading ? <CircularProgress color="inherit" size={18} /> : "Claim"}
                                    </button>
                                    <button className="btn m-3 activeButton roleButton" src="" onClick={unstakeAll} style={{ backgroundColor: '#00ff84', fontWeight: '500' }}>
                                        {loading ? <CircularProgress color="inherit" size={18} /> : "Unstake All"}
                                    </button>
                                </div> :
                                <></>
                            }

                        </div>
                        :
                        <>
                            <>
                                <div className='staking-info-container'>
                                    <p className='minttitle title'>Staking Page</p>
                                    <div className='mintInfoBox'>
                                        <span className='p-2'>Coming Soon</span>
                                        {/* <span className='p-2'>There is no minted NFT. Please mint NFT first</span>
                                        <a href="https://opensea.io/collection/executive-r0ar-society/overview" target="_blank" rel="noreferrer">
                                            <button className="navConnectButton" style={{ marginLeft: '0px' }}>
                                                Mint Now
                                            </button>
                                        </a>
                                        <span className='p-2'>There is no staked NFT. Please stake NFT first</span> */}
                                    </div>
                                </div>
                            </>
                        </>}
                </div>
            </section>

            {/* <Footer /> */}
        </section>
    )
}

export default StakingPage;
